import { render, staticRenderFns } from "./ServiceAccountCard.vue?vue&type=template&id=589f8ed7&"
import script from "./ServiceAccountCard.vue?vue&type=script&lang=js&"
export * from "./ServiceAccountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports